import { Carousel, EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { AnimateInsertion } from '@/components/switchback/AnimateInsertion';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { getCampgroundCategories } from '@/redux/modules/bundles';
import {
  getCampgroundCategoriesSelector,
  getIsCampgroundCategoriesLoadingSelector,
} from '@/redux/selectors/bundles';

import css from './Categories.module.css';
import { CategoryItem } from './CategoryItem';

export const Categories = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const categories = useSelector(getCampgroundCategoriesSelector);
  const isLoading = useSelector(getIsCampgroundCategoriesLoadingSelector);
  const { isAboveDesktop } = useBreakpoint();

  const title = intl.formatMessage({
    defaultMessage: 'Categories',
    id: 'VKb1MS',
  });

  useEffect(() => {
    dispatch(getCampgroundCategories());
  }, [dispatch]);

  const carouselContent = categories?.map(category => (
    <CategoryItem key={category.id} {...category} />
  ));

  if (isLoading || !carouselContent || categories?.length === 0) {
    return null;
  }

  return (
    <AnimateInsertion>
      <div>
        {!isAboveDesktop && (
          <div className="px-6">
            <Heading variant={EHeadingStyleVariant.H4} className="font-normal text-center text-850">
              {title}
            </Heading>
            <div className="mt-5 grid grid-cols-2 gap-3">{carouselContent}</div>
          </div>
        )}

        {isAboveDesktop && (
          <div className={css.carousel}>
            <Carousel title={title} content={carouselContent} slidesPerView={4.7} removePadding />
          </div>
        )}
      </div>
    </AnimateInsertion>
  );
};
